export default __webpack_public_path__ + "static/img/logo_icon.505fbcf.png";